import { render, staticRenderFns } from "./TicketReplyBox.vue?vue&type=template&id=4728a36c&scoped=true"
import script from "./TicketReplyBox.vue?vue&type=script&lang=js"
export * from "./TicketReplyBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4728a36c",
  null
  
)

export default component.exports